import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {User} from '../../models/user';
import {Validation} from '../../util/validation/validation';

@Component({
    selector: 'emc-user-info',
    templateUrl: 'user-info.html',
    styleUrls: ['user-info.scss']

})
export class UserInfoComponent implements OnInit {
    userInfoForm: FormGroup;
    isPasswordStrong = false;
    // tslint:disable-next-line:no-input-rename
    @Input('googleUser') googleUser: User;

    constructor(public formBuilder: FormBuilder) {}
    ngOnInit(): any {

      this.userInfoForm = new FormGroup({
            name: new FormControl('', [Validators.required, Validators.minLength(3), Validation.nameValidator.bind(this)]),
          // fiscalNumber: new FormControl('', [Validators.required, Validators.minLength(9), Validation.fiscalNumberValidator.bind(this)]),
            phoneNumber: new FormControl('', [Validators.required, Validation.phoneValidator.bind(this)]),
            email: new FormControl('', [Validators.required, Validators.email]),
            passwordGroup: new FormGroup({
                password: new FormControl('', [Validators.required]),
                confirmPassword: new FormControl('', [Validators.required])
            }, [Validators.required, Validation.confirmPasswordValidator.bind(this)])
        });

      if (this.googleUser) {
          this.userInfoForm.patchValue({
              firstName: this.googleUser.name,
              email: this.googleUser.email
          });
          this.userInfoForm.get('email').disable();
      }
    }

    isValid(field: string) {
        let isValid = true;
        if (this.userInfoForm.get(field).errors !== null) {
            isValid = false;
        }
        return isValid;
    }

    strengthChanged(num: number) {
        const pass = this.userInfoForm.get('passwordGroup').get('password').value;

        if (num > 1) {
            this.isPasswordStrong = true;
        } else {
            this.isPasswordStrong = false;
        }
    }
}
